import { Button } from "@/components/ui/Button";
import { Search, FilePlus, MapPin, CloudSun } from "lucide-react";
import { cn } from "@/lib/utils";

interface ChatSuggestProps {
  onSendMessage?: (message: string) => void;
}

export function ChatSuggest({ onSendMessage }: ChatSuggestProps) {
  const actions = [
    {
      label: "帮我找货",
      icon: Search,
      iconColor: "text-blue-500",
    },
    {
      label: "创建新订单",
      icon: FilePlus,
      iconColor: "text-green-500",
    },
    {
      label: "查询订单路况",
      icon: MapPin,
      iconColor: "text-red-500",
    },
    {
      label: "查询天气信息",
      icon: CloudSun,
      iconColor: "text-yellow-500",
    },
  ];

  const handleActionClick = (label: string) => {
    if (onSendMessage) {
      onSendMessage(label);
    }
  };

  return (
    <div className="p-4 w-fit max-w-md mx-auto">
      <div className="grid grid-cols-2 gap-x-[1.5625rem] gap-y-4 justify-items-center">
        {actions.map((action, index) => (
          <Button
            key={index}
            variant="outline"
            onClick={() => handleActionClick(action.label)}
            className={cn(
              "h-[2.5rem]",
              "rounded-full bg-white hover:bg-slate-50 shadow-sm",
              "gap-[0.4375rem]",
              "px-4 text-sm font-normal text-slate-600",
              "w-auto"
            )}
          >
            <action.icon className={cn("h-4 w-4", action.iconColor)} />
            <span>{action.label}</span>
          </Button>
        ))}
      </div>
    </div>
  );
}
